/**
 * Converts a user-entered search term into a case-insensitive wildcard matcher.
 * Supports `*` (any sequence of characters) and `?` (any single character);
 * all other characters (including regex metacharacters) are matched literally.
 * A term with no wildcard characters behaves like a plain "contains" search.
 *
 * Shared across the Workflow Management dashboards (Job Management, All Open
 * Cases, Submissions, Land, Engineering, Planning, Scheduling, Execution,
 * Close-out, Facility Decommission, Non-Rig) so client-side row search
 * consistently supports wildcards.
 */
export function wildcardToMatcher(query: string): (text: string) => boolean {
  const escaped = query
    .replace(/[.+^${}()|[\]\\]/g, '\\$&')
    .replace(/\*/g, '.*')
    .replace(/\?/g, '.');
  try {
    const regex = new RegExp(escaped, 'i');
    return (text: string) => regex.test(text);
  } catch {
    const lower = query.toLowerCase();
    return (text: string) => text.toLowerCase().includes(lower);
  }
}
